"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateModelInstance = void 0;
const parsePayload_1 = __importDefault(require("./parsePayload"));
const parseQuery_1 = __importDefault(require("./parseQuery"));
const updateModel = async (Model, payload, options) => {
    var _a;
    await Model._init();
    options = Object.assign({}, {
        hooks: true,
        clearCache: true,
        upsert: true,
        parse: true,
    }, options);
    // if (Model.translatable && !payload.translations && Model._client._project?.locales?.length) {
    //   payload.translations = Model._client._project?.locales;
    // }
    if (payload.locale && payload.locale === ((_a = Model._client._project) === null || _a === void 0 ? void 0 : _a.defaultLocale)) {
        delete payload.locale;
    }
    let config = Object.assign(Object.assign({}, (options.config || {})), { global: Model.isGlobal });
    const args = { payload, config };
    if (options.hooks) {
        const responses = await Model.execHook("preUpdate", [args]);
        if (responses === null || responses === void 0 ? void 0 : responses.includes(false)) {
            return;
        }
    }
    payload = args.payload;
    config = args.config;
    try {
        if (options.parse) {
            if (payload.query) {
                payload.query = (0, parseQuery_1.default)(payload.query);
            }
            if (payload.set) {
                payload.set = (0, parsePayload_1.default)(payload.set);
            }
        }
        const { data } = await Model.handleUpdateCall(payload, config);
        if (!data) {
            return data;
        }
        const items = Model.handleUpdatedData(data.data.rows, options.upsert);
        if (options.hooks) {
            await Model.execHook("postUpdate", [items, null, payload]);
        }
        return items;
    }
    catch (e) {
        if (options.hooks) {
            await Model.execHook("postUpdate", [null, e, payload]);
        }
        throw e;
    }
};
const updateModelInstance = async (instance, payload, options) => {
    var _a, _b;
    options = Object.assign({}, {
        hooks: true,
        clearCache: false,
        upsert: undefined,
        preStore: false,
        revertOnError: undefined,
    }, options);
    options.upsert = (_a = options.upsert) !== null && _a !== void 0 ? _a : !options.preStore;
    options.revertOnError = (_b = options.revertOnError) !== null && _b !== void 0 ? _b : options.preStore;
    const _id = payload._id || instance._id;
    payload.query = { _id };
    const constructor = instance.constructor;
    // if (constructor.translatable && !payload.translations && constructor._client._project?.locales?.length) {
    //   payload.translations = constructor._client._project?.locales;
    // }
    if (constructor.translatable && payload.locale === undefined && instance._locale) {
        payload.locale = instance._locale;
    }
    let config = {};
    const args = { payload, instance, config };
    if (options.hooks) {
        const responses = await constructor.execHook("preUpdate", [args]);
        if (responses === null || responses === void 0 ? void 0 : responses.includes(false)) {
            return;
        }
    }
    payload = args.payload;
    instance = args.instance;
    config = args.config;
    if (payload.query) {
        payload.query = (0, parseQuery_1.default)(payload.query);
    }
    if (payload.set) {
        payload.set = (0, parsePayload_1.default)(payload.set);
    }
    const backup = instance.clone();
    if (options.preStore) {
        instance.assign(payload.set);
    }
    if (instance.isTemporary()) {
        console.warn("You tried to update a temporary document");
        return instance;
    }
    try {
        await updateModel(constructor, payload, {
            clearCache: options.clearCache,
            upsert: options.upsert,
            hooks: false,
            parse: false,
            config,
        });
        if (options.upsert) {
            const found = constructor.get(_id, false);
            instance.assign(found.raw, false, false);
        }
        else {
            instance.assign(null, false);
        }
        if (options.hooks) {
            await constructor.execHook("postUpdate", [[constructor.get(_id)].filter(Boolean), null, payload]);
        }
    }
    catch (e) {
        if (options.revertOnError) {
            constructor.upsertStore([backup]);
        }
        if (options.hooks) {
            await constructor.execHook("postUpdate", [null, e, payload]);
        }
        throw e;
    }
};
exports.updateModelInstance = updateModelInstance;
exports.default = updateModel;
